<template>
	<b-container class="pg-instruction-cont">
		<img
			class="pg-img-pos"
			src="../../assets/newdesign/dashboard/games/cross-haze.svg"
			alt=""
		/>
		<span class="pg-blue-txt d-flex w80">Crosswords Game Instructions</span>
		<h2 class="mt-3 mb-2">Objective :</h2>
		<h3>Fill the grid with correct words based on the given clues.</h3>
		<h2 class="mt-3 mb-2">How to Play :</h2>
		<main class="d-flex pl-1">
			<h4 class="mr-1">1.</h4>
			<section>
				<h4>Read Clues :</h4>
				<h3>Use the numbered clues for Across and Down words.</h3>
			</section>
		</main>
		<main class="d-flex pl-1 mt-2">
			<h4 class="mr-1">2.</h4>
			<section>
				<h4>Type Answers :</h4>
				<h3>
					Click on the grid cells and type the correct word that matches the
					clue.
				</h3>
			</section>
		</main>
		<main class="d-flex pl-1 mt-2">
			<h4 class="mr-1">3.</h4>
			<section>
				<h4>Crossing Letters :</h4>
				<h3>
					Words share common letters, which can help you solve intersecting
					clues.
				</h3>
			</section>
		</main>
		<main class="d-flex pl-1 mt-2">
			<h4 class="mr-1">4.</h4>
			<section>
				<h4>Check Progress :</h4>
				<h3>
					Some crossword puzzles allow you to check if your answers are correct
					as you go.
				</h3>
			</section>
		</main>
	</b-container>
</template>

<script>
export default {};
</script>

<style></style>
